<template>
    <div class="right_container" style="padding:0 0 0 0;">
        <div class="bar create_project" :style="'height:'+bar_height+'px;'">
            <span class="fl"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>编辑项目</span>
            <!--<span class="auto_saved" v-if="auto_saved">{{auto_text}}</span>-->
        </div>

         <div v-for="(item,index) in templates" :key="index+''">
            <v-datepicker v-if="item.type=='TimePicker'" :moduel="item" :projectData="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name" v-on:listenToChildEvent="checkParams"  type='edit'> </v-datepicker>
            <v-input v-if="item.type=='input'" :moduel="item" :projectData ="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name"  v-on:listenToChildEvent="checkParams" :projectNum="project_num" type='edit'> </v-input>
            <v-select v-if="item.type=='select'"  :moduel="item" :projectData.sync ="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name" v-on:listenToChildEvent="checkParams" type='edit'></v-select>
            <v-selectObj v-if="item.type=='select_by_api'&&item.key_name != 'customer_ids'" :moduel="item" :projectData.sync="project_data" v-model='project_data[item.key_name]' v-on:listenToChildEvent="checkParams"  :ref="'project'+item.key_name" type='edit'> </v-selectObj>
            <v-selectObj v-if="item.type=='select_by_api'&&item.key_name == 'customer_ids'" :moduel="item" :projectData.sync="project_data" v-model='project_data[item.key_name]' v-on:listenToChildEvent="checkParams" :ref="'project'+item.key_name" type='edit'> </v-selectObj>
            <uc_editor v-if="item.type=='text'"  :moduel="item" :data="project_data" v-model='project_data[item.key_name]'  :ref="'project'+item.key_name"  :input_callback="set_edit_project_description" type='edit'></uc_editor>
        </div>
    </div>
</template>

<script>
export default {
  name:'',
  data(){
    return {
        edit_project_sunbmit:false,
        bar_height:40,
        btn_height:54,
        project_tips:'',
        timer:'',
        customer_ids:[],
        user_list:[],
        project_user_list:[],
        content:'',
        name:'',
        createTime:'',
        add_project_sunbmit:false,
        // show_ellipsis:false,
        description_high:0,
        function_type1:''
    }
  },
  props:["height", "width","templates",'project_id',"web_token","user_info","web_url","project_data","project_num"],
  // store,
  methods:{
    set_edit_project_description: function(_content, _height){
      this.project_data.description = _content;
      this.project_data.description_high = _height;
      if(_content != ''){
        this.edit_project("auto");
      }
    },
    backToLogin(){
      this.$router.push('/login');
    },
    // 关闭添加
    close_edit_wrapper(){
        var that = this;
        this.$confirm('正在编辑项目，离开会丢失录入的内容，是否确定离开？', '提示', {
            cancelButtonText: '继续编辑',
            confirmButtonText: '确定离开',
            type: 'warning'
        }).then(() => {
            //TODO: 切换项目
           this.editors_clear("project_edit");
           this.function_type1 = 1;
           this.$emit('input', this.function_type1);
        }).catch(() => {

        });
    },
    listenToChildGet_focus(){
        this.show_save = true;
        console.log(this.show_save)
    },
    checkParams(){
      this.role_change();
      for(var i=0; i< this.templates.length; i++) {
        if(this.templates[i].required){
          if(this.project_data[this.templates[i].key_name] == '' || this.project_data[this.templates[i].key_name] == []){
                this.edit_project_sunbmit = false;
                return false;
          }
        }
      }
      this.edit_project_sunbmit = true;
    //   this.edit_project();
      if(this.edit_project_sunbmit){
           this.edit_project();
      }
    },
    // 人员改变 项目角色不能重复
    role_change(){
      var user_role = ['leader_user_ids','manage_user_ids','join_user_ids'];
        for(var i=0; i< this.templates.length; i++) {
            if(user_role.indexOf(this.templates[i].key_name) > -1){
                var ref = 'project'+this.templates[i].key_name;
                if(ref in this.$refs){
                    this.$refs[ref][0].user_change();
                }
            }
       }
    },
    editors_clear: function(name){
      for(var i=0; i< this.templates.length; i++) {
        var ref = name +this.templates[i].key_name;
        if(ref in this.$refs){
          this.$refs[ref][0].clear();
        }
      }
    },
    // 编辑项目
    edit_project(edit_type, _call_back){
        this.project_data.web_token = this.web_token;
        this.$http.post(this.web_url+'/project/'+this.project_id+'/edit',this.project_data,{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
               this.$emit("edit_project_success");
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }else {
            //   this.edit_tips( res.data.message);
            //   this.show_save = false;
              // var _this = this;
              //  clearInterval(this.timer);
              //  this.project_tips =  res.data.message;
              //  this.timer = setInterval(function(){
              //     _this.project_tips =  '';
              //  },2000);
            }
            if(typeof(_call_back) === "function"){
              _call_back();
            }
          })
        .catch(function(res1){
          var _this = this;
          clearInterval(this.timer);
          this.project_tips = '网络出错';
          this.timer = setInterval(function(){
            _this.project_tips =  '';
          },2000);
        });
    },
    editors_clear: function(name){
      for(var i=0; i< this.templates_project.length; i++) {
        var item = this.templates_project[i];
        var ref = name +item.key_name;
        if(ref in this.$refs){
          this.$refs[ref][0].clear();
        }
      }
    },
  },
  mounted(){
     console.log(this.project_num)
  },
  created() {
  },
}
</script>




// WEBPACK FOOTER //
// src/components/edit_project.vue